module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"listedOf":"Show {0} of {1}"},"de":{"listedOf":"Zeige {0} von {1}"},"fr":{"listedOf":"Montrer {0} de {1}"},"it":{"listedOf":"Listo {0} di {1}"}}')
  delete Component.options._Ctor
}
